import { Button, Col, Row } from 'antd';
import { Panel } from 'components/ui/index';
import classNames from 'classnames/bind';
import React from 'react';
import { injectIntl } from 'react-intl';
import Enums from 'utils/EnumsManager';
import RecentlyTag from './recentlyTag';
import TodayTag from './todayTag';
import styles from './index.less';

const { Recently, Today } = Enums;
const cx = classNames.bind(styles);

class LeftTopModal extends React.Component {
  handleTagChange = (value) => {
    const { setTagValue } = this.props;
    setTagValue(value);
  }

  render() {
    const {
      leads, accounts, objects, intl, setRouteInfo, tagView, todayNewTotal,
    } = this.props;
    const { formatMessage } = intl;

    const panelButton = (
      <div>
        <Button
          className={`ml-sm ${tagView === Recently ? 'checkedBtn' : 'panelBtn'} ${cx('text-btn')}`}
          size="small"
          onClick={() => {
            this.handleTagChange(Recently);
                }}
        >{ formatMessage({ id: 'page.dashboard.recently' })}
        </Button>
        <Button
          className={`ml-sm ${tagView === Today ? 'checkedBtn' : 'panelBtn'} ${cx('text-btn')}`}
          size="small"
          onClick={() => {
            this.handleTagChange(Today);
                }}
        >{ formatMessage({ id: 'page.dashboard.today' })}
        </Button>
      </div>
    );

    return (
      <Row>
        <Col className="gutter-row mr-lg" span={24}>
          <Panel panelClasses="creamyWhite-header-panel" actionsRight={panelButton}>
            {tagView === Recently &&
              <RecentlyTag
                leads={leads}
                accounts={accounts}
                objects={objects}
              />
            }
            {tagView === Today &&
              <TodayTag
                todayNewTotal={todayNewTotal}
                setRouteInfo={setRouteInfo}
              />
            }
          </Panel>
        </Col>
      </Row>
    );
  }
}

export default injectIntl(LeftTopModal);



// WEBPACK FOOTER //
// ./src/views/Dashboard/components/leftTopModal/index.jsx